import { createReducer } from 'typesafe-actions';

import type { HydrateAction } from '../actions';
import { nextHydrate } from '../hydrate';
import { reconcileState } from '../utils';

import {
  getAllOnboardingContractsAction,
  getSignedOnboardingContractsAction,
  signOnboardingContractsAction,
} from './actions';
import type {
  OnboardingContractAction,
  OnboardingContractState,
} from './types';

export const initialOnboardingContractState: OnboardingContractState = {
  contracts: [],
  haveOnboardingContractsBeenRequested: false,
  haveSignedOnboardingContractsBeenRequested: false,
  signedContracts: [],
};

export const onboardingContractReducer = createReducer<
  OnboardingContractState,
  OnboardingContractAction | HydrateAction
>(initialOnboardingContractState)
  .handleAction(
    getAllOnboardingContractsAction.success,
    (state, { payload }) => {
      return {
        ...state,
        contracts: payload,
        haveOnboardingContractsBeenRequested: true,
      };
    }
  )
  .handleAction(
    getSignedOnboardingContractsAction.success,
    (state, { payload }) => {
      return {
        ...state,
        haveSignedOnboardingContractsBeenRequested: true,
        signedContracts: payload,
      };
    }
  )
  .handleAction(signOnboardingContractsAction.success, (state, { payload }) => {
    return {
      ...state,
      haveSignedOnboardingContractsBeenRequested: true,
      signedContracts: [...state.signedContracts, payload],
    };
  })
  .handleAction(nextHydrate, (state, { payload: { onboardingContract } }) => ({
    ...state,
    ...reconcileState(onboardingContract, initialOnboardingContractState),
  }));
